import React, { useState, useEffect } from 'react';
import FreeEstimationForm from '../get_free_estimation/Page';
import '../get_free_estimation/module.FreeEstimationForm.css';
import './PartnerSection.css';

const PartnerSection = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [showForm, setShowForm] = useState(false);

  useEffect(() => {
    setIsVisible(true);
    
    // Add scroll animation for elements
    const handleScroll = () => {
      const elements = document.querySelectorAll('.partner_feature-item, .partner_cta-button');
      elements.forEach(el => {
        const elementTop = el.getBoundingClientRect().top;
        const windowHeight = window.innerHeight;
        if (elementTop < windowHeight - 100) {
          el.classList.add('partner_animate');
        }
      });
    };

    window.addEventListener('scroll', handleScroll);
    handleScroll(); // Initial check

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const handleGetEstimateClick = () => {
    setShowForm(true);
    // Prevent body scroll when modal is open
    document.body.style.overflow = 'hidden';
  };

  const handleCloseForm = () => {
    setShowForm(false);
    // Restore body scroll
    document.body.style.overflow = 'auto';
  };

  return (
    <>
      <div className="partner_container">
        {/* Animated background elements */}
        <div className="partner_animated-bg">
          <div className="partner_bg-circle partner_bg-circle-1"></div>
          <div className="partner_bg-circle partner_bg-circle-2"></div>
          <div className="partner_bg-circle partner_bg-circle-3"></div>
          <div className="partner_bg-circle partner_bg-circle-4"></div>
        </div>
        
        <div className={`partner_content ${isVisible ? 'partner_fade-in' : ''}`}>
          <div className="partner_header">
            <h2 className="partner_title">
              Why Contractors Choose <span className="partner_accent">SuryaGroup</span>?
            </h2>
            <p className="partner_subtitle">
              Trusted partner for accurate, reliable & fast construction estimates.
            </p>
          </div>

          <div className="partner_features">
            <div className="partner_feature-list">
              <div className="partner_feature-item">
                <div className="partner_feature-icon">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div className="partner_feature-content">
                  <h3 className="partner_feature-title">Save 30% project time</h3>
                  <p className="partner_feature-desc">with accurate takeoffs</p>
                </div>
              </div>
              <div className="partner_feature-item">
                <div className="partner_feature-icon">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div className="partner_feature-content">
                  <h3 className="partner_feature-title">Trusted by US & Canada contractors</h3>
                  <p className="partner_feature-desc">with proven results</p>
                </div>
              </div>
              <div className="partner_feature-item">
                <div className="partner_feature-icon">
                  <i className="fas fa-check-circle"></i>
                </div>
                <div className="partner_feature-content">
                  <h3 className="partner_feature-title">Dedicated estimator support</h3>
                  <p className="partner_feature-desc">for every project</p>
                </div>
              </div>
            </div>
          </div>

          <div className="partner_divider">
            <div className="partner_divider-line"></div>
          </div>

          <div className="partner_cta">
            <button 
              className="partner_cta-button" 
              onClick={handleGetEstimateClick}
            >
              <span className="partner_cta-text">GET FREE ESTIMATE</span>
              <i className="fas fa-arrow-right partner_cta-icon"></i>
            </button>
          </div>
        </div>
      </div>

      {/* Free Estimation Form Modal */}
      {showForm && (
        <FreeEstimationForm onClose={handleCloseForm} />
      )}
    </>
  );
};

export default PartnerSection;